import { render, staticRenderFns } from "./UpgradePopup.vue?vue&type=template&id=489a5fc0&scoped=true&"
import script from "./UpgradePopup.vue?vue&type=script&lang=js&"
export * from "./UpgradePopup.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePopup.vue?vue&type=style&index=0&id=489a5fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a5fc0",
  null
  
)

/* custom blocks */
import block0 from "./UpgradePopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports